import moment from 'moment-jalaali';

import { Tour as API } from '@src/api/types';
import { generateBusiness, generateUser } from '@src/factories';
import { Tour as Data } from '@src/types';

const Factory = (api: API): Data => ({
  id: api.wpPostId.toString(),
  title: api.title,
  cover: {
    uri: api.imageUrl,
  },
  price: api.price,
  booking: api.bookingOption,
  duration: api.duration,
  operator: generateUser(api.operator),
  description: api.rawDescription,
  includes: api.includes,
  excludes: api.excludes,
  startBusiness: api.beginningBusiness
    ? generateBusiness(api.beginningBusiness)
    : undefined,
  businesses: api.businesses.map((business) => generateBusiness(business)),
  orderURL: api.orderUrl,
  beginDate: api.beginDate,
  endDate: api.endDate,
  capacity: api.capacity,
  rate: api.rate,
  difficulty: api.difficulty,
  vehicle: api.vehicle,
  leaderId: api.leaderId,
  shareURL: api.shareUrl,
  programs: api.programs.map((program) => ({
    title: program.title,
    description: program.desc,
  })),
  geopoint: {
    latitude: api.latitude,
    longitude: api.longitude,
  },
});

export default Factory;
